export default
 [{
    path: '/',
    component: require('./components/site/Index.vue').default,
    meta:{menu:'konsultant'}
},{
    path: '/client',
    component: require('./components/client/ClientIndex.vue').default,
    meta:{menu:'client'}
},

{
    path: '/client/:id/sms',
    component: require('./components/client/ClientSms.vue').default,
    meta:{menu:'client'}
},
 {
    path: '*',
    component: require('./components/NotFound.vue').default,
    meta:{menu:''}
},{
    path: '/sites',
    component: require('./components/site/Index.vue').default,
    meta:{menu:'site'}
}];